<greco-simple-dialog [data]="dialogData">
  <form [formGroup]="formGroup">
    <mat-form-field appearance="standard" floatLabel="always" appearance="standard" style="width: 100%">
      <mat-label>Title</mat-label>
      <input matInput type="text" [required]="true" formControlName="title" [required]="true" />
    </mat-form-field>
  </form>
</greco-simple-dialog>
